<template>
  <div id="landingPageHolder">
    <div class="contentHolder">
      <img class="logo" src="../assets/fisher-insta-meetings.svg"/>
      <h2 class="userName">Hi, Please sign in to continue...</h2>
      <form class="signInForm">
        <div class="form-group">
          <label>Email address</label>
          <input type="email" v-model="user" :class="errors ? 'error' : ''"/>
        </div>
        <div class="form-group">
          <label>Password</label>
          <input type="password" :class="errors ? 'error' : ''" v-model="password"/>
        </div>
        <button type="submit" class="signInBtn" @click.prevent="signInSubmit()">Sign In</button>
      </form>
    </div>
  </div>
</template>

<script>
/* eslint-disable no-debugger */
import {mapActions, mapGetters} from "vuex";
import axios from "axios";

export default {
  name: "SignIn",
  components: {},
  data() {
    return {
      user: "",
      password: "",
      errors: false,
      authPersonId: 0
    };
  },
  computed: mapGetters(["meetingModalOpen", "getMeetingModalType"]),
  methods: {
    ...mapActions(["decryptData", "getAuthToken"]),
    signInSubmit() {
      console.log(process.env.VUE_APP_GRAPHQL_URL);
      console.log(process.env.NODE_ENV);
      const data = {
        username: this.user,
        password: this.password,
      };
      const headers = {
        "Content-Type": "application/json",
        "Authorization": null,
      };//TODO url to graphql
      axios
          // .post(`https://localhost:5004/api/user/authenticate`, data, {
          .post(process.env.VUE_APP_GRAPHQL_URL, data, {
            headers: headers
          })
          .then(response => {
            console.log(response);
            this.authPersonId = response.data.personId
            if (response.status === 200) {
              // let data = decodeURIComponent(this.$route.query.data);
              // data = encodeURIComponent(data);
              console.log("auth success!");

              let encryptedData = this.$route.query.data;
              this.decryptData(encryptedData).then((response) => {
                if (this.authPersonId === this.$store.state.personId) {

                  this.getAuthToken().then((result) => {
                    if (result !== ""
                        && this.$store.state.personId > 0
                        && this.$store.state.userId > 0
                        && this.$store.state.roleId > 0) {

                      // this.fetchLeaderDetails(this.$store.state.personId);
                      // this.fetchMeetings(this.$store.state.personId);
                      sessionStorage.setItem("userSignedIn", true);
                      this.$store.commit('setSignedInUser', true);
                      this.$router.push(`/meetings?data=${this.$route.query.data}`);

                    }
                  });
                } else {
                  this.errors = true
                  this.$confirm({
                    message: `Ooops you have a corrupted link! Please login to FISHER aplication and try again.`,
                  });
                }
              }).catch((error) => {
                console.log(error);
                this.$confirm({
                  message: `Ooops your link has expired! Please login to FISHER aplication and try again.`,
                });
              });


            } else {
              this.errors = true
            }
          })
          .catch(error => {
            console.log(error);
            this.errors = true
          });
    },
  },
};
</script>

<style lang="scss" scoped src="@/styles/style-landing.scss">
</style>
